/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Order_Payment_1Inputs */

const vi_carrier_order_payment_1 = /** @type {(inputs: Carrier_Order_Payment_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thu tiền`)
};

/**

* @param {Carrier_Order_Payment_1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_order_payment_1 = /** @type {((inputs?: Carrier_Order_Payment_1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Order_Payment_1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_order_payment_1(inputs)
});